import { NotificationType } from './enums';
import { useStores } from '../components/store';
import { toast } from '../components/shared/toast-notifications';
import usePromiseFeedback from '../components/shared/promise-feedback/usePromiseFeedback';
import { useNavigate } from 'src/utils/use-navigate';

export const usePull = () => {
    const { fwVersionStore, customerStore } = useStores();
    const [promiseFeedbackFactory] = usePromiseFeedback();
    const navigate = useNavigate();

    const goToDraft = (endpoint = fwVersionStore.versionProtectionPath) => {
        const draftId = fwVersionStore.draftVersion?.externalId;
        if (draftId) {
            navigate(`/${customerStore.customerId}/${customerStore.serviceId}/protection/version/${draftId}/${endpoint}`,
                {replace: true});
        }
    };

    const goToLatestVersion = (endpoint = fwVersionStore.versionProtectionPath) => {
        const latestId = fwVersionStore.latestVersion?.externalId;
        if (latestId) {
            navigate(`/${customerStore.customerId}/${customerStore.serviceId}/protection/version/${latestId}/${endpoint}`,
                {replace: true});
        }
    };

    const pullAsDraft = (successCb: () => void, errorCb: () => void, connectionId?: number, sourceCircuitId?: string, endpoint?: string) => {
        promiseFeedbackFactory({
            promise: fwVersionStore.pull(connectionId, sourceCircuitId),
            successCallback: () => {
                toast(NotificationType.SUCCESS,
                    `Policy was saved as draft v${fwVersionStore.draftVersion?.versionNumber}`);
                successCb();
                goToDraft(endpoint);
            },
            errorCallback: () => {
                errorCb();
            },
            notifObj: {show: false}
        });
    };

    const pullAndApply = (policyName: string, policyComments: string, successCb: () => void, errorCb: () => void,
                                reloadVersion: boolean,connectionId?: number, sourceCircuitId?: string) => {
        if (!connectionId || !sourceCircuitId) return;
        promiseFeedbackFactory({
            promise: fwVersionStore.pullPolicyAndApply(connectionId, sourceCircuitId, policyName, policyComments),
            successCallback: async () => {
                successCb();
                if (reloadVersion) {
                    await fwVersionStore.loadVersionsList();
                    goToLatestVersion();
                }
            },
            errorCallback: () => {
                errorCb();
            },
            notifObj: {show: false}
        });
    };

    return { pullAsDraft, pullAndApply, goToDraft };
};